import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ProductCard from "@/components/ProductCard";
import API from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { Heart } from "lucide-react";

export default function WishlistPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [wishlistIds, setWishlistIds] = useState([]);
  const { user } = useAuth();
  const { t } = useLanguage();
  const isReseller = ["reseller", "agen", "mitra", "produsen", "distributor", "admin"].includes(user?.role);

  useEffect(() => {
    Promise.all([
      API.get("/wishlist").then((r) => setProducts(r.data.products)),
      API.get("/wishlist/ids").then((r) => setWishlistIds(r.data.product_ids))
    ]).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen" data-testid="wishlist-page">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <h1 className="font-serif text-3xl text-stone-900 mb-8" data-testid="wishlist-title">{t("wishlist.title")}</h1>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
            {[1,2,3,4].map((i) => (
              <div key={i} className="animate-pulse"><div className="aspect-[3/4] bg-stone-200 mb-4" /><div className="h-4 bg-stone-200 w-2/3 mb-2" /></div>
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20">
            <Heart className="w-12 h-12 text-stone-300 mx-auto mb-4" />
            <p className="text-stone-500 mb-4">{t("wishlist.empty")}</p>
            <Link to="/products" className="text-sm text-primary hover:opacity-80">{t("wishlist.browse")}</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12" data-testid="wishlist-grid">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} showReseller={isReseller} wishlistIds={wishlistIds} onWishlistChange={() => {
                API.get("/wishlist").then((r) => setProducts(r.data.products));
                API.get("/wishlist/ids").then((r) => setWishlistIds(r.data.product_ids));
              }} />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
